import * as React from 'react'
import { Slot } from '@radix-ui/react-slot'
import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '../../lib/utils.ts'

const buttonVariants = cva(
  'inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-[var(--radius-md)] font-medium transition-colors disabled:pointer-events-none aria-disabled:cursor-not-allowed [&_svg]:pointer-events-none [&_svg]:shrink-0',
  {
    variants: {
      variant: {
        default: 'bg-[var(--primary)] text-[var(--primary-foreground)] hover:brightness-110',
        outline: 'border border-[var(--input)] bg-transparent hover:bg-[var(--muted)] hover:border-[var(--foreground)]/20',
        ghost: 'hover:bg-[var(--muted)]',
        secondary: 'bg-[var(--secondary)] text-[var(--secondary-foreground)] hover:brightness-95',
        destructive: 'bg-[var(--destructive)] text-[var(--destructive-foreground)] hover:brightness-110',
        // dílo v seznamu: klik = odebrat, proto hover přechází do destruktivní barvy
        selected:
          'border border-[var(--work-selected)] bg-[var(--work-selected)] text-[var(--work-selected-foreground)] hover:bg-[var(--destructive)] hover:border-[var(--destructive)]',
      },
      size: {
        default: 'h-[var(--control-height)] px-4 text-[length:var(--text-sm)]',
        sm: 'h-8 px-3 text-[length:var(--text-xs)]',
        lg: 'h-11 px-6 text-[length:var(--text-base)]',
        icon: 'h-[var(--control-height)] w-[var(--control-height)]',
      },
    },
    defaultVariants: { variant: 'default', size: 'default' },
  },
)

export type ButtonProps = React.ComponentProps<'button'> &
  VariantProps<typeof buttonVariants> & { asChild?: boolean }

export function Button({ className, variant, size, asChild = false, ...props }: ButtonProps) {
  const Comp = asChild ? Slot : 'button'
  return <Comp className={cn(buttonVariants({ variant, size }), className)} {...props} />
}

export { buttonVariants }
